<div class="locations-container">

    <app-location-list class="location-list" [(selectedLocation)]="selectedLocation"></app-location-list>
    <app-location-detail class="location-detail" [location]="selectedLocation"></app-location-detail>

</div>
